import PropTypes from 'prop-types'
import classNames from 'classnames'
import RegItemImage from 'registry/components/reg-item-image'
import FundingProgress from 'registry/components/reg-item-card/group-gift-reg-item-card/funding-progress'
import css from 'registry/components/reg-item-card/reg-item-card-layout.scss'
import pluralize from 'pluralize'
import { BestOfferLink } from 'registry/components/reg-item-card/best-offer-link/best-offer-link'
import { StarRating } from 'baby-design'
import ShopItemActions from './shop-item-actions'
import OwnerMarkAsPurchasedAction from './owner-mark-as-purchased-action'
import BuyingOptionsLink from './buying-options-link'
import { PriceDisplay } from './price-display'

const ShopItem = ({
  item,
  registryDiscountAvailable,
  storeName,
  openRedirectModal,
}) => {
  const {
    fundedAmount,
    goalAmount,
    id,
    imgUrl,
    isAvailableOnBabylist,
    isFavorite,
    isGroupGift,
    offers,
    price,
    product,
    productId,
    quantity,
    quantityNeeded,
    quantityPurchased,
    title,
  } = item
  const storeOffer = offers.find((o) => o.storeName == storeName)
  const isBabylist = storeOffer?.isBabylist
  const hasReviews = product?.reviewCount > 0

  const renderBanner = () => {
    if (quantity > 1 && quantityPurchased < quantity) {
      return (
        <div className="text-center">
          {quantityNeeded} of {quantity} Needed
        </div>
      )
    }
  }
  return (
    <div className={`${css.layout} flex justify-start pvl bbs`}>
      <div className="prl">
        <BestOfferLink
          isShopRegistryView
          isContributorView={isBabylist}
          offers={offers}
        >
          <RegItemImage
            bannerContent={renderBanner()}
            className={css.productImage}
            isFavorite={isFavorite}
            isGroupGift={isGroupGift}
            src={imgUrl}
            width={300}
          />
        </BestOfferLink>
      </div>
      <div className="flex-grow prs-md">
        <BestOfferLink
          isShopRegistryView
          isContributorView={isBabylist}
          offers={offers}
        >
          <div className={classNames('mbs mtn text-body')}>{title}</div>
        </BestOfferLink>
        <div className={classNames('pull-left')}>
          {product && isAvailableOnBabylist && hasReviews && (
            <div className="flex-grow">
              <StarRating
                rating={product?.rating}
                reviewCount={product?.reviewCount}
              />
            </div>
          )}
        </div>
        <div className="flex-grow align-end">
          <PriceDisplay
            isAvailableOnBabylist={isAvailableOnBabylist}
            isEligibleForRegistryDiscount={
              registryDiscountAvailable && product?.eligibleForRegistryDiscount
            }
            msrp={product?.price?.msrp}
            price={storeOffer?.price || price}
          />
        </div>
        {isGroupGift && (
          <FundingProgress
            isContributorView
            className="bts ptm"
            fundedAmount={fundedAmount}
            goalAmount={goalAmount}
          />
        )}

        <div className="flex align-end justify-end flex-grow ptl">
          <div>
            <div className={css.shopItemActionsWrapper}>
              <ShopItemActions
                openRedirectModal={openRedirectModal}
                quantityNeeded={quantityNeeded}
                regItem={item}
                storeName={storeName}
              />
            </div>
            <div className="flex flex-grow align-center justify-end mtl">
              {!isAvailableOnBabylist && (
                <OwnerMarkAsPurchasedAction
                  quantity={quantityNeeded}
                  regItemId={id}
                />
              )}
              {offers && offers.length > 1 && (
                <div className="flex align-end justify-end mll">
                  <BuyingOptionsLink
                    brand={product?.brand}
                    imageUrl={imgUrl}
                    name={title}
                    offers={offers}
                    openRedirectModal={openRedirectModal}
                    productId={productId}
                    regItemId={id}
                  >
                    <div className="ll small lh-m link-info">
                      {`+ ${offers.length - 1} Buying ${pluralize(
                        'Options',
                        offers.length - 1
                      )}`}
                    </div>
                  </BuyingOptionsLink>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

ShopItem.propTypes = {
  item: PropTypes.object.isRequired,
  openRedirectModal: PropTypes.func.isRequired,
  registryDiscountAvailable: PropTypes.bool.isRequired,
  storeName: PropTypes.string.isRequired,
}

export default ShopItem
